// GeographicalRegions.tsx
import { DataTable } from "@/components";
import useGeographicalRegions from "./useGeographicalRegions";
import { Button } from "@/components/ui";
import { filter } from "@/assets";
import { Filter } from "./Filter";

const GeographicalRegions = () => {
  const {
    columns,
    onAdd,
    onCancelFilter,
    onFilterBtnClick,
    openFilter,
    filterData,
    setFilterData,
    onRowClick,
    tableData,
    isPending,
    isError,
    error,
    pageNumber,
    pageSize,
    totalPages,
    totalRecords,
    setPageNumber,
    setPageSize,
  } = useGeographicalRegions();

  return (
    <>
      <div className="mb-4 px-5 flex justify-end gap-3">
        <Button type="button" variant="ghost" onClick={onFilterBtnClick}>
          <img src={filter} alt="Filter" />
          Filter
        </Button>
        <Button onClick={onAdd}>+ Add New</Button>
      </div>
      {isPending && <div className="px-5 py-3">Loading...</div>}
      {isError && (
        <div className="px-5 py-3">
          Error: {error?.message || "Failed to fetch data"}
        </div>
      )}
      {!isPending && !isError && (
        <DataTable
          columns={columns}
          data={tableData}
          // onRowClick={onRowClick}
          serviceSidePagination
          pageNumber={pageNumber}
          pageSize={pageSize}
          totalPages={totalPages}
          totalRecords={totalRecords}
          setPageNumber={setPageNumber}
          setPageSize={setPageSize}
        />
      )}
      {openFilter && (
        <Filter
          onCancel={onCancelFilter}
          filterData={filterData}
          setFilterData={setFilterData}
        />
      )}
    </>
  );
};

export default GeographicalRegions;